import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Package, CalendarPlus, Clock, Flag, Users, UserPlus, Ban } from 'lucide-react';

const TILES = [
  { key: 'active_posts', label: 'Active posts', Icon: Package, color: '#7A9A78' },
  { key: 'posts_today', label: 'Posts today', Icon: CalendarPlus, color: '#2C5545' },
  { key: 'expired_posts', label: 'Expired posts', Icon: Clock, color: '#8A8F87' },
  { key: 'reported_posts', label: 'Reported posts', Icon: Flag, color: '#C86F53' },
  { key: 'total_users', label: 'Total users', Icon: Users, color: '#D99E4A' },
  { key: 'new_users_today', label: 'New users today', Icon: UserPlus, color: '#7A6FC8' },
  { key: 'banned_users', label: 'Banned / suspended', Icon: Ban, color: '#9A4A4A' },
];

export default function DashboardPanel() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get('/admin/stats').then(r => setStats(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="dashboard-panel">
      <h2 className="font-display font-bold text-2xl text-brand-ink mb-1">Dashboard</h2>
      <p className="text-brand-slate text-sm mb-6">A live snapshot of your community.</p>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {TILES.map(({ key, label, Icon, color }) => (
          <div key={key} data-testid={`stat-${key}`} className="glass-panel rounded-3xl p-5 flex items-center gap-4">
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center shrink-0" style={{ background: color + '22' }}>
              <Icon className="w-6 h-6" style={{ color }} />
            </div>
            <div>
              <div className="font-display font-black text-3xl text-brand-ink leading-none">{stats[key] ?? '—'}</div>
              <div className="text-xs text-brand-slate mt-1">{label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
